export const SearchIssuerStyles = {
	mainContainer: "flex flex-col justify-center items-center w-full",
	searchContainer: "w-full sm:w-4/4 md:w-3/4 flex justify-start items-center bg-iw-background shadow-iw gradient-outline-input rounded-lg",
	searchIcon: "m-2 sm:m-3 md:m-4 lg:m-5",
	searchInput: "py-2 sm:py-3 md:py-4 lg:py-6 w-3/4 sm:w-11/12 focus:outline-none overflow-ellipsis ml-0 mr-2 sm:mr-3 md:mr-4 lg:mr-10 text-[14px] leading-[20px] text-[#9E9E9E] font-medium",
	clearSearchIcon: "m-2 sm:m-3 md:m-4 lg:m-5 cursor-pointer",
	helperAndErrorTextContainer: "text-left w-full sm:w-4/4 md:w-3/4 mt-3",
	regexError: "text-iw-red text-[14px] leading-[20px]",
	infoMsg: "text-iw-closeIcon text-[14px] leading-[20px]"
};